import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  FormFeedback,
  ModalFooter,
  Table,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Label,
  Button,
  Input,
  Form,
  FormGroup,
  UncontrolledAlert,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
// import { Table, Row, Col, Button, Input, CardBody ,Label} from "reactstrap";
//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"
import { DEALERPROFILEUPDATE, HOSTNAME } from "config/config"
import axios from "axios"
const getUserData = JSON.parse(localStorage.getItem("authUser"))
const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [username, setusername] = useState("Admin")
  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.displayName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.username)
      }
    }
  }, [props.success])

  const [modal, setModal] = useState(false)

  const profiletoggle = () => {
    setModal(!modal)
    // alert("hello")
  }
  const [dealerData, setdealerData] = useState({})
  const profiletoggle1 = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOSTNAME}${DEALERPROFILEUPDATE}`,
      headers: {
        Authorization: `${getUserData.userData.token}`,
      },
    }

    axios
      .request(config)
      .then(response => {
        console.log(response.data.data)
        setdealerData(response.data && response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
    setModal(!modal)
    // alert("hello")
  }

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      agencyname: "",
      dealername: "",
      contactNumber: "",
      city: "",
    },
    validationSchema: Yup.object({
      agencyname: Yup.string().required("Please Enter Your Agency Name"),
      dealername: Yup.string().required("Please Enter Your Dealer Name"),
      contactNumber: Yup.string().required(
        "Please Enter Customer Contact Number"
      ),
      city: Yup.string().required("Please Enter City"),
    }),
    onSubmit: (values, { resetForm }) => {
      console.log("values=>>>>", values)
    },
  })

  const buttonStyle = {
    // position: 'relative',
    // backgroundColor: '#007bff', // Primary color
    // color: '#ffffff',
    // border: 'none',
    // padding: '10px 20px',
    // fontSize: '16px',
    // cursor: 'pointer'
  }

  const tooltipStyle = {
    visibility: "hidden",
    backgroundColor: "#000",
    color: "#fff",
    textAlign: "center",
    padding: "5px",
    borderRadius: "6px",
    position: "absolute",
    zIndex: "1",
    // bottom: '125%', /* Position the tooltip above the button */
    // left: '50%',
    // marginLeft: '-60px', /* Adjust this value to center the tooltip */
    opacity: "0",
    transition: "opacity 0.3s",
  }

  const handleHover = () => {
    document.getElementById("tooltip").style.visibility = "visible"
    document.getElementById("tooltip").style.opacity = "1"
  }

  const handleLeave = () => {
    document.getElementById("tooltip").style.visibility = "hidden"
    document.getElementById("tooltip").style.opacity = "0"
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <Link to="#" className="dropdown-item"
         onClick={()=>{profiletoggle1();}}
          >
            <i className="bx bxs-user-rectangle font-size-16 align-middle me-1 text-primary" />
            <span>{props.t("Profile")}</span>
          </Link> */}

          <Link
            to="#"
            className="dropdown-item"
            onClick={() => {
              tog_backdrop()
            }}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>

      <Modal
        isOpen={modal_backdrop}
        toggle={() => {
          tog_backdrop()
        }}
        backdrop={"static"}
        id="staticBackdrop"
        size="sm"
      >
        <div className="modal-header">
          <h3 className="modal-title" id="staticBackdropLabel">
            <i
              className="bx bx-power-off align-middle me-1 text-danger"
              style={{ fontSize: "30px" }}
            />
            Logout
          </h3>
        </div>
        <div className="modal-body">
          <b>
            <p>Are you sure you want to logout ???</p>
          </b>
        </div>

        <div className="modal-footer">
          <Link to="/logout">
            <button type="button" className="btn btn-primary">
              Yes
            </button>
          </Link>

          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              setmodal_backdrop(false)
            }}
          >
            No
          </button>
        </div>
      </Modal>

      {/* modal */}
      <Modal
        isOpen={modal}
        role="dialog"
        size="md"
        autoFocus={true}
        centered
        id="verificationModal"
        toggle={profiletoggle}
      >
        <div className="modal-content">
          <Form onSubmit={validation.handleSubmit}>
            <ModalHeader toggle={profiletoggle}>Your Profile</ModalHeader>

            <ModalBody>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom01">Agency Name</Label>
                    <Input
                      name="agencyname"
                      placeholder="Agency Name"
                      type="text"
                      className="form-control"
                      id="validationCustom01"
                      disabled
                      // onChange={dealerData && dealerData.agencyName}
                      onBlur={validation.handleBlur}
                      value={dealerData && dealerData.agencyName}
                      invalid={
                        validation.touched.agencyname &&
                        validation.errors.agencyname
                          ? true
                          : false
                      }
                    />
                    {validation.touched.agencyname &&
                    validation.errors.agencyname ? (
                      <FormFeedback type="invalid">
                        {validation.errors.agencyname}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom01">Dealer Name</Label>
                    <Input
                      name="dealername"
                      placeholder="Dealer Name"
                      type="text"
                      className="form-control"
                      id="validationCustom01"
                      disabled
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={
                        dealerData
                          ? dealerData.firstName + " " + dealerData.lastName
                          : ""
                      }
                      invalid={
                        validation.touched.dealername &&
                        validation.errors.dealername
                          ? true
                          : false
                      }
                    />
                    {validation.touched.dealername &&
                    validation.errors.dealername ? (
                      <FormFeedback type="invalid">
                        {validation.errors.dealername}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom01">Contact Number</Label>
                    <Input
                      name="contactNumber"
                      placeholder="Contact Number"
                      type="number"
                      className="form-control"
                      id="validationCustom01"
                      disabled
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={dealerData && dealerData.contactNumber}
                      invalid={
                        validation.touched.contactNumber &&
                        validation.errors.contactNumber
                          ? true
                          : false
                      }
                    />
                    {validation.touched.contactNumber &&
                    validation.errors.contactNumber ? (
                      <FormFeedback type="invalid">
                        {validation.errors.contactNumber}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom01">City</Label>
                    <Input
                      name="city"
                      placeholder="City"
                      type="text"
                      className="form-control"
                      id="validationCustom01"
                      disabled
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={dealerData && dealerData.city}
                      invalid={
                        validation.touched.city && validation.errors.city
                          ? true
                          : false
                      }
                    />
                    {validation.touched.city && validation.errors.city ? (
                      <FormFeedback type="invalid">
                        {validation.errors.city}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter style={{ display: "flex", justifyContent: "left" }}>
              {/* <Button type="button" title="Your Tooltip Text Here" color="primary">Update</Button> */}

              <Button
                type="button"
                color="primary"
                onMouseEnter={handleHover}
                onMouseLeave={handleLeave}
              >
                Update
                <span id="tooltip" style={tooltipStyle}>
                  To update your profile contact Admin
                </span>
              </Button>
              <Button type="button" onClick={profiletoggle} color="secondary">
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
